{
  "version": 1,
  "asset_id": "5bdeae0f-163f-4733-b56b-fa09785edd7d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5bdeae0f-163f-4733-b56b-fa09785edd7d/loc-round-rock-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5bdeae0f-163f-4733-b56b-fa09785edd7d/loc-round-rock-640.webp",
  "original_filename": "loc-round-rock-640.webp",
  "size": 34322,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:31Z"
}
